/* eslint-disable no-underscore-dangle */
import { AxiosPromise } from 'axios';
import client from '../core';

const getPassedGames = (): AxiosPromise<any> => client.get('game/results');

const getPassedGamesCount = (): AxiosPromise<any> =>
  client.get('game/count', { timeout: 5000 });

const saveGameResults = async (data) => {
  await client.post('game', {
    ...data,
  });
};

const finishActivity = (): AxiosPromise<any> => client.post('game/finish');

export default {
  getPassedGames,
  getPassedGamesCount,
  saveGameResults,
  finishActivity,
};
